











































































































import { Component, Vue, Ref } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { SegmentoDTO } from "@/models/commons/SegmentoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";

@Component({
  components: {
    GsModalDialog,
    ValidationObserver,
    ValidationProvider
  },
})
export default class Segmento extends Vue {
  @Ref()
  crudObserver!: InstanceType<typeof ValidationObserver>;

  lista: SegmentoDTO[] = [];
  loading = false;
  exibeModalConfirmacao = false;

  cabecalho = [
      { text: "Descrição", value: "descricao", width: "60%" },
      { text: "Ações", value: "actions", width: "10%", sortable: false }
  ];

  crud: SegmentoDTO = { 
    id: 0, 
    descricao: ""
  };

  dialogType = "success";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  valid = true;

  alterar(model: SegmentoDTO) {
    this.crud = Object.assign({}, model);
  }

  beforeMount() {
    this.obter();
  }

  obter() {
    this.loading = true;
    this.lista = [];
    ServicosAssistenciaService
    .obterSegmentos(
      ).then((res: SegmentoDTO[]) => {
          this.lista = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  salvar() {
      let valid = true;
      if (this.crud.descricao == "") {
        this.crudObserver.setErrors({
          descricao: "O campo Descrição é obrigatório",
        });
        valid = false;
        this.openDialog('info', 'Dados inválidos.', 'Preencha uma descrição válida');
      }
      
      if (valid) {
        ServicosAssistenciaService
        .salvarSegmento(
          this.crud
        ).then((res: SegmentoDTO) => {        
          if (this.crud.id > 0) {
            this.openDialog('success', "Alteração realizada com sucesso", "Alteração realizada com sucesso");
          } else {
            this.openDialog('success', "Inclusão realizada com sucesso", "Inclusão realizada com sucesso");
          }
          this.resetar();
        })
        .catch((err) => {
          this.resetar();
          console.log(err);
          this.openDialog('error', 'Erro ao realizar ação.', 'Ocorreu um erro ao tentar gravar os dados.');
        });
      }    
  }

  excluir() {
    this.loading = true;

    ServicosAssistenciaService.excluirSegmento(this.crud.id)
    .then(() => {
      this.obter();  
      this.openDialog('success', 'Sucesso', `O segmento ${this.crud.descricao} foi excluído com sucesso`);
      this.resetar();
      this.exibeModalConfirmacao = false;
    })
    .catch(() => {
       this.openDialog('error', 'Erro ao realizar a exclusão do segmento.', 'Erro ao realizar a exclusão do segmento. Verifique se o segmento ainda existe.');
       this.exibeModalConfirmacao = false;
    })
  }

  solicitarExclusao(crud: SegmentoDTO) {
    this.crud = crud;
    this.exibeModalConfirmacao = true;
  }

  cancelarSolicitacaoExclusao() {
    this.resetar();
    this.exibeModalConfirmacao = false;
  }

  resetar() {
    this.crud.id = 0;
    this.crud.descricao = "";
    this.valid = true;
    this.obter();
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }
}
